import { Component, inject, OnInit } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { ChatMessage, FetchedDocument } from '../../documentation-chat';
import { FileDownloaderButtonComponent } from '../../../../../components/documents/file-downloader-button/file-downloader-button.component';
import { DocumentationSourceComponent } from '../documentation-source/documentation-source.component';
import { MaintenanceSourceComponent } from '../maintenance-source/maintenance-source.component';

export class ChatSourcesDialogInput {
    constructor(public message: ChatMessage) { }
}

export class ChatSourcesDialogResult {
    constructor(public readonly closed: boolean) { }
}

@Component({
    selector: 'phito-chat-sources-dialog',
    standalone: true,
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatButton,
        FileDownloaderButtonComponent,
        DocumentationSourceComponent,
        MaintenanceSourceComponent
    ],
    templateUrl: './chat-sources-dialog.component.html',
    styleUrl: './chat-sources-dialog.component.scss',
})
export class ChatSourcesDialogComponent implements OnInit {
    dialogRef = inject<MatDialogRef<ChatSourcesDialogComponent>>(MatDialogRef);
    dialogData = inject<ChatSourcesDialogInput>(MAT_DIALOG_DATA);

    maintenanceDocuments: FetchedDocument[] = [];
    documentationDocuments: FetchedDocument[] = [];

    ngOnInit(): void {
        for (const s of this.dialogData?.message?.sources ?? []) {
            if (!s.relatedApiPath) {
                if (s.apiPath === 'documentations') {
                    this.documentationDocuments.push(s);
                } else if (s.apiPath === 'maintenances') {
                    this.maintenanceDocuments.push(s);
                }
            }
        }
    }

    close(): void {
        this.dialogRef.close(new ChatSourcesDialogResult(true));
    }
}
